/**
 * MoraleBar Component
 * Displays settlement morale with color coding and effect description
 */
export function MoraleBar({ morale }) {
  const getColor = (m) => {
    if (m >= 75) return 'bg-green-500';
    if (m >= 50) return 'bg-yellow-500';
    if (m >= 25) return 'bg-orange-500';
    return 'bg-red-500';
  };

  const getEffect = (m) => {
    if (m >= 75) return '+1 to all rolls';
    if (m >= 50) return 'Normal performance';
    if (m >= 25) return '-1 to rolls, 5% defection';
    return '-2 to rolls, 15% defection';
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between mb-1">
        <span className="text-sm font-medium">😊 Morale: {morale}/100</span>
        <span className="text-xs text-gray-400">{getEffect(morale)}</span>
      </div>
      <div className="w-full bg-gray-700 h-3 rounded">
        <div
          className={`h-3 rounded ${getColor(morale)}`}
          style={{ width: `${morale}%` }}
        />
      </div>
    </div>
  );
}
